import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import IconModal from '@components/IconModal';
import { IconModalProps } from '@components/IconModal/IconModal';
import BlueCheck from '@images/blue_check.png';
import Image from 'next/image';

const FamilyModal = (props: IconModalProps & { fromQuoter?: boolean }) => {
  const { t } = useTranslation();
  return (
    <IconModal {...props} icon={<Image src={BlueCheck} height={80} width={80} alt="blue_check" />}>
      <div className="flex flex-1 flex-col gap-4">
        <span className="font-bold heading/s leading-heading/s text-neutral/darkgrey/90">
          {t('family_modal.title')}
        </span>
        <span className="font-normal text-paragraph/s paragraph/s text-color/neutral/80">
          {t('family_modal.content')}
        </span>
        <div className="flex flex-col gap-1">
          <span className="font-semibold text-paragraph/s paragraph/s text-color/neutral/80">
            {t('family_modal.content_list_title_relationship')}
          </span>
          <Trans
            t={t}
            i18nKey={'family_modal.content_list_relationship'}
            components={{
              ul: <ul className="list-disc pl-6" />,
              li: <li className="font-normal text-paragraph/s paragraph/s text-color/neutral/80" />,
            }}
          />
        </div>
        <span className="font-normal text-paragraph/s paragraph/s text-color/neutral/80">
          {t('family_modal.content_warning')}
        </span>
        <div className="flex flex-col gap-1">
          <span className="font-semibold text-paragraph/s paragraph/s text-color/neutral/80">
            {t('family_modal.content_list_title_age')}
          </span>
          <Trans
            t={t}
            i18nKey={'family_modal.content_list_age'}
            components={{
              ul: <ul className="list-disc pl-6" />,
              li: <li className="font-normal text-paragraph/s paragraph/s text-color/neutral/80" />,
            }}
          />
        </div>

        <div className="flex flex-col gap-1">
          <span className="font-semibold text-paragraph/s paragraph/s text-color/neutral/80">
            {t('family_modal.content_title_beneficiaries')}
          </span>
          <span className="font-normal text-paragraph/s paragraph/s text-color/neutral/80">
            {t('family_modal.content_description_beneficiaries')}
          </span>
        </div>
        <span className="font-normal text-paragraph/s paragraph/s text-color/neutral/80">
          {props?.fromQuoter
            ? t('family_modal.content_next_step_quoter')
            : t('family_modal.content_next_step')}
        </span>
      </div>
    </IconModal>
  );
};

export default FamilyModal;
